export const GLOBAL_STORE_RESET = 'global/GLOBAL_STORE_RESET';
export const SET_GLOBAL_COLLAPSED = 'global/SET_GLOBAL_COLLAPSED';
